
import React from 'react';
import { Phone, Mail } from 'lucide-react';

const ChatFooter: React.FC = () => {
  return (
    <div className="p-3 bg-[#0a0c1b]/80 rounded-b-xl">
      <div className="text-xs text-white/70 mb-2">Or reach out to our team directly:</div>
      <div className="flex justify-around">
        <a 
          href="sms:+18179337408" 
          className="flex items-center gap-1 text-sm text-white/90 hover:text-white transition-colors"
        >
          <Phone className="h-4 w-4" />
          <span>Text</span>
        </a>
        <a 
          href="mailto:hello@raiselaunch.com" 
          className="flex items-center gap-1 text-sm text-white/90 hover:text-white transition-colors"
        >
          <Mail className="h-4 w-4" />
          <span>Email</span>
        </a>
      </div>
    </div>
  );
};

export default ChatFooter;
